import { Modal } from 'bootstrap';

window.addEventListener('DOMContentLoaded', () => {
	const friendModal = document.getElementById('friend-modal');

	if (friendModal) {
		const allFriends = document.querySelectorAll('.friends-picture');
		const modalLink = friendModal.querySelector('.modal__content a');
		const modalPicture = friendModal.querySelector('.friends-modal-picture picture');
		const modalPictureSource = modalPicture.querySelector('source');
		const modalPictureImage = modalPicture.querySelector('img');
		const modalContent = friendModal.querySelector('.friends-modal-content');

		allFriends.forEach(element => {
			element.addEventListener('click', () => {
				const myModal = new Modal(friendModal);
				let { name, text, url, webpImage, jpgImage } = element.dataset;
				modalLink.href = url;
				modalPictureSource.srcset = webpImage;
				modalPictureImage.src = jpgImage;
				modalPictureImage.title = name;
				modalContent.innerHTML = text;
				myModal.show();
			})
		})
	}
});
